import {resolveBackground} from '#core/utils/color-utils.js';

import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';
import {
    generatePrimaryButton,
    generateTertiaryButton,
    generateToggleButton,
} from '#core/application/modules/tiles/button/index.js';
import {CLOSE_BUTTON_TYPES, generateCloseButton} from '#core/application/modules/tiles/close-button/index.js';

export function quickStartGuideDialogConfig(PALETTE) {
    const {FONT} = PALETTE;

    const QSG_DIALOG_SKELETON_PART = generateSkeletonPart(PALETTE.QSG_DIALOG_SKELETON_PART);

    return {
        QuickStartGuideDialogSkeleton: {
            fullWidth: QSG_DIALOG_SKELETON_PART,
            halfOfWidth: QSG_DIALOG_SKELETON_PART,
            thirdOfWidth: QSG_DIALOG_SKELETON_PART,
            button: QSG_DIALOG_SKELETON_PART,
        },
        QuickStartGuideDialog: {
            headerText: {
                style: {
                    fontFamily: FONT.FAMILY,
                    fontWeight: FONT.WEIGHT_BOLD,
                    fontSize: '18px',
                    ...PALETTE.QSG_DIALOG_TITLE_TEXT,
                },
            },
            headerSkeleton: QSG_DIALOG_SKELETON_PART,
            dialog: {
                background: resolveBackground(PALETTE.QSG_DIALOG_CONTAINER_BG),
                padding: '0 16px 16px',
                borderStyle: {
                    borderRadius: '8px',
                },
                header: {
                    container: {
                        borderStyle: {
                            borderWidth: 0,
                        },
                    },
                },
                closeButton: generateCloseButton(PALETTE.QSG_DIALOG_CLOSE_BUTTON, CLOSE_BUTTON_TYPES.CIRCULAR),
            },
            button: generateToggleButton(PALETTE.QSG_DIALOG_GUIDE_BUTTON).unselected,
            buttonsMenuContainer: {
                defaultColumnSize: '48.5%',
            },
            description: {
                isHtml: true,
                style: {
                    fontFamily: FONT.FAMILY,
                    fontSize: '14px',
                    ...PALETTE.QSG_DIALOG_TEXT,
                },
                container: {
                    flexGrow: 0,
                },
            },
            additionalInfo: {
                style: {
                    fontFamily: FONT.FAMILY,
                    fontSize: '14px',
                    ...PALETTE.QSG_DIALOG_TEXT,
                },
            },
            nextButton: generatePrimaryButton(PALETTE.QSG_DIALOG_NEXT_BUTTON),
            backToMenuButton: generateTertiaryButton(PALETTE.QSG_DIALOG_BACK_TO_MENU_BUTTON),
        },
    };
}
